import { all } from 'redux-saga/effects'
import authSaga from './auth'
import orderSaga from './order'
import userProgramSaga from './userProgram'

export default function* rootSaga() {
  yield all([authSaga(), orderSaga(), userProgramSaga()])
}
